<template>
	<div class="m_container" :class="openType != 'mob' ? 'flex_center flex_items vh100' : ''">
		<div class="plr20 pt20 page_bg" style="box-sizing: border-box;" :class="openType != 'mob' ? 'container_w_h' : 'vh100'">
			<div class="bgfff mb20 b_r_10 plr10 pt20 pb20 mb20">
				<div class="page_title mb10">项目信息<van-icon name="edit" class="pointer ml20" size="24" v-if="!ed" @click="handleClick" /></div>
				<div class="pl15">
					<div class="flex flex_start flex_warp mb20 flex_items">
						<div class="ca6 mr10 l1" style="word-break:keep-all;">项目名称</div>
              <div class="flex1 l1" v-if="!ed">{{detail.name}}</div>
              <div class="flex1 l1" v-else>
                <input type="text" id="inputId" v-model="detail.name" @blur="handleB">
              </div>
            
					</div>
					<!-- <div class="flex flex_start mb20">
						<div class="ca6 mr10">活动时间</div>
						<div class="mr10 flex1">2022-06-98</div>
					</div>
					<div class="flex flex_start">
						<div class="ca6 mr10">活动介绍</div>
						<div class="mr10 flex1">2活动介绍活动介绍活动介绍活动介绍活动介绍活动介绍活动介绍</div>
					</div> -->
				</div>
			</div>
			<div class="bgfff flex flex_between plr10 pt20 pb20 t" style="border-radius: 10px 10px 0 0;">
				<div class="flex flex_column txt_center" @click="$router.push({path:'/msetSignList',query:{id:id}})">
					<van-icon name="orders-o" class="mb10" size="40" />
					签到表
				</div>
				<div class="flex flex_column txt_center" @click="$router.push({path:'/leave',query:{id:id}})">
					<van-icon name="todo-list-o" class="mb10" size="40" />
					请假审批
				</div>
				<div class="flex flex_column txt_center" @click="$router.push({path:'/attendance',query:{id:id,t:1}})">
					<van-icon name="notes-o" class="mb10" size="40" />
					出勤明细
				</div>
			</div>
			<div class="bgfff flex flex_between plr10 pt20 pb20 t" style="border-radius:0 0 10px 10px ;">
				<div class="flex flex_column txt_center" @click="$router.push({path:'/attendance',query:{id:id,t:2}})">
					<van-icon name="records" class="mb10" size="40" />
					出勤汇总
				</div>
				<div class="flex flex_column txt_center" @click="$router.push({path:'/memberlist',query:{id:id}})">
					<van-icon name="friends-o" class="mb10" size="40" />项目人员
				</div>
				<div class="flex flex_column txt_center" @click="$router.push({path:'/projectSetting',query:{id:id}})">
					<van-icon name="points" class="mb10" size="40" />
					积分
				</div>
			</div>
			<div class="bgfff flex flex_between plr10 pt20 pb20 t" style="border-radius:0 0 10px 10px ;">
				<div class="flex flex_column txt_center" @click="del">
					<van-icon name="cross" class="mb10" size="40" />
					删除
				</div>
			</div>
		</div>
		<!-- <div class="bottom_btn " @click="del">
			<div class="btn_contenbt">
				删除项目
			</div>
		</div> -->
	</div>
</template>
<script>
	import {
		openType
	} from '@/utils/tool.js'
	import { Dialog } from 'vant';
	export default ({
		data() {
			return {
				detail: {},
				id: 1,
				openType: openType(),
        ed:false
			}
		},
		created() {
			this.openType = openType()
			this.id = this.$route.query.id;
			this.getList()
		},
		methods: {
      handleB(){
        console.log(this.detail);
        this.api.changeProjectName({name:this.detail.name,status:this.detail.status},this.id).then(res => {
					this.Toast('修改成功')
				})
        this.ed = false
      },
      handleClick(){
        this.ed = !this.ed
        this.$nextTick(() => {
          document.getElementById('inputId').focus()
        })
      },
			getList() {
				this.api.projectView({},this.id).then(res => {
					this.detail = res.data
				})
			},
			del(){
				Dialog.confirm({
				  title: '删除',
				  message:
				    '确定要删除此项目？',
				})
				  .then(() => {
				    // on confirm
						this.api.projectDelete({},this.id).then(res => {
							this.Toast('删除成功')
							setTimeout(() =>{
								window.history.go(-1)
							},1500)
						})
				  })
				  .catch(() => {
				    // on cancel
				  });
			}
		}
	})
</script>
<style scoped="scoped">
	.t>div{
		width: 28%;
	}
</style>